export const getTrackingUrl = (tracking: string) => `https://auspost.com.au/mypost/track/details/${tracking}`;
